const customTooltip = () => {
  document.addEventListener('DOMContentLoaded', function () {
    const tooltips = document.querySelectorAll('.custom-tooltip');

    tooltips.forEach(tooltipBlock => {
      const tooltipBtn = tooltipBlock.querySelector('img');
      const closeTooltip = tooltipBlock.querySelector('.tooltip-message .close');

      if (!tooltipBlock || !tooltipBtn) return;

      tooltipBtn.addEventListener('click', function () {
        tooltipBlock.classList.add('show-tooltip');
      });

      if (closeTooltip) {
        closeTooltip.addEventListener('click', function () {
          tooltipBlock.classList.remove('show-tooltip');
        });
      }
    });
  });

  const dateFields = document.querySelectorAll('.add_active');

  dateFields.forEach(field => {
    const toggleFilledClass = () => {
      if (field.value) {
        field.classList.add('filled');
      } else {
        field.classList.remove('filled');
      }
    };

    field.addEventListener('change', toggleFilledClass);
    field.addEventListener('input', toggleFilledClass);

    toggleFilledClass();
  });
};

export default customTooltip;
